/* @flow */

import React from 'react';
import styled from '@emotion/styled';
import Label from 'app/components/commons/Label';

type Props = {
  className?: string,
  items?: Array<Object>
};

const defaultProps = {
  className: undefined,
  items: []
};

const PlayerLabelsList = styled.ul({
  display: 'flex',
  listStyle: 'none',
  margin: 0,
  padding: 0
});

const PlayerLabelsItem = styled.li({
  color: 'white',
  display: 'flex',
  margin: 0,
  paddingLeft: 3
});

function PlayerLabels({ className, items = [] }: Props) {
  return (
    <PlayerLabelsList className={className}>
      {items.map(item => (
        <PlayerLabelsItem key={item.id}>
          <Label bgColor={item.bgColor} textColor={item.textColor}>
            {item.name}
          </Label>
        </PlayerLabelsItem>
      ))}
    </PlayerLabelsList>
  );
}

PlayerLabels.defaultProps = defaultProps;

export default PlayerLabels;
